import { CommandGetJourneySteps } from "./commands/cmdGetJourneySteps";
import {
  CommandCreateJourneyStep,
  CreateJourneyStepPayload,
} from "./commands/cmdCreateJourneyStep";
import { CommandListJourneys } from "./commands/cmdListJourneys";
import { CommandCreateJourney, CreateJourneyPayload } from "./commands/cmdCreateJourney";
import {
  CommandUpdateJourneyStep,
  UpdateJourneyStepPayload,
} from "./commands/cmdUpdateJourneyStep";
import { CommandDeleteJourneyStep } from "./commands/cmdDeleteJourneyStep";
import { CommandSearchJourneySteps } from "./commands/cmdSearchJourneySteps";
import {
  CommandCopyJourneySteps,
  CopyJourneyStepsPayload,
} from "./commands/cmdCopyJourneySteps";
import {
  CommandListJourneyStepDimensions,
  CommandCreateJourneyStepDimension,
  CommandUpdateJourneyStepDimension,
  CommandDeleteJourneyStepDimension,
  JourneyStepDimensionPayload,
} from "./commands/cmdJourneyStepDimensions";

export class JourneyService {
    async listJourneys() {
        const cmd = new CommandListJourneys()
        return await cmd.run()
    }

    async createJourney(payload: CreateJourneyPayload) {
        const cmd = new CommandCreateJourney()
        return await cmd.run(payload)
    }

    async getJourneySteps(journeyId: number) {
        const cmd = new CommandGetJourneySteps()
        const results = await cmd.run(journeyId)
        return results;
    }

    async searchSteps(query: string) {
        const cmd = new CommandSearchJourneySteps()
        return await cmd.run(query)
    }

    async createStep(journeyId: number, payload: CreateJourneyStepPayload) {
        const cmd = new CommandCreateJourneyStep()
        return await cmd.run(journeyId, payload)
    }

    async updateStep(journeyId: number, stepId: number, payload: UpdateJourneyStepPayload) {
        const cmd = new CommandUpdateJourneyStep()
        return await cmd.run(journeyId, stepId, payload)
    }

    async deleteStep(journeyId: number, stepId: number) {
        const cmd = new CommandDeleteJourneyStep()
        return await cmd.run(journeyId, stepId)
    }

    async copyJourneySteps(journeyId: number, payload: CopyJourneyStepsPayload) {
        const cmd = new CommandCopyJourneySteps()
        return await cmd.run(journeyId, payload)
    }

    async listStepDimensions(journeyId: number, stepId: number) {
        return await new CommandListJourneyStepDimensions().run(journeyId, stepId)
    }

    async createStepDimension(journeyId: number, stepId: number, payload: JourneyStepDimensionPayload) {
        return await new CommandCreateJourneyStepDimension().run(journeyId, stepId, payload)
    }

    async updateStepDimension(journeyId: number, stepId: number, id: number, payload: JourneyStepDimensionPayload) {
        return await new CommandUpdateJourneyStepDimension().run(journeyId, stepId, id, payload)
    }

    async deleteStepDimension(journeyId: number, stepId: number, id: number) {
        return await new CommandDeleteJourneyStepDimension().run(journeyId, stepId, id)
    }
}
